import React from "react";
import {H1, Paragraph} from "@reside/ui";

export const DefaultSignOverlay = (): JSX.Element => {
  return (
    <>
      <H1 fontSize={[5, 6, 7, 8]} fontWeight="bold">
        Sign Admission
      </H1>
      <Paragraph fontSize={[3, 4]}>
        You are about to SIGN this Admission. This action cannot be undone -
        once the Admission is signed, our Facility Representative will review
        its content and come back to you with potential issues. Once the content
        of the Admission is correct, it will be approved and will become a valid
        contract between the Facility and the Resident.
      </Paragraph>
      <Paragraph fontSize={[3, 4]}>
        Please confirm that you are sure about this action.
      </Paragraph>
    </>
  );
};
